import autoTable from "jspdf-autotable";
import { PDFCOLORSHEME } from "../../../../../../component/constent";

function format(value) {
  return Number(value || 0).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// =====================================================
// DEMAND TOTAL
// =====================================================

export function drawDemandTotal(doc, demand, totals = {}) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 8
    : 35;

  const pageHeight = doc.internal.pageSize.getHeight();

  // Demand total should have enough space
  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 30;
  }

  autoTable(doc, {
    startY,

    theme: "grid",

    tableWidth: 270,

    body: [
      [
        `DEMAND ${demand} TOTAL`,
        format(totals.dl),
        format(totals.ds),
        format(totals.ocl),
        format(totals.ocs),
        format(totals.total),
      ],
    ],

    styles: {
    
      fontSize: PDFCOLORSHEME.FONT_SIZE_GRAND_TOTAL,

      cellPadding: 2,

      halign: "right",

      textColor:
        PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
    },

    columnStyles: {
      0: {
        cellWidth: 45,
        halign: "left",
        fontStyle: "bold",
      },

      1: {
        cellWidth: 45,
        halign: "right",
      },

      2: {
        cellWidth: 45,
        halign: "right",
      },

      3: {
        cellWidth: 45,
        halign: "right",
      },

      4: {
        cellWidth: 45,
        halign: "right",
      },

      5: {
        cellWidth: 45,
        halign: "right",
      },
    },

    didParseCell(data) {
      if (data.section === "body") {
        data.cell.styles.fontStyle = "bold";

        data.cell.styles.fillColor =
          PDFCOLORSHEME.BACK_COLOR_GROUP1;
      }
    },
  });
}


// =====================================================
// GRAND TOTAL
// =====================================================

export function drawGrandTotal(doc, totals = {}) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 8
    : 35;

  const pageHeight =
    doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 40) {
    doc.addPage();
    startY = 35;
  }

  autoTable(doc, {
    startY,

    theme: "grid",

    tableWidth: 270,

    body: [
      [
        "GRAND TOTAL",
        format(totals.dl),
        format(totals.ds),
        format(totals.ocl),
        format(totals.ocs),
        format(totals.total),
      ],
    ],

    styles: {
      fontSize:
        PDFCOLORSHEME.FONT_SIZE_GRAND_TOTAL,

      cellPadding: 2,

      halign: "right",

      textColor:
        PDFCOLORSHEME.FONT_COLOR_GRAND_TOTAL,
    },

    columnStyles: {
      0: {
        cellWidth: 45,
        halign: "left",
        fontStyle: "bold",
      },

      1: {
        cellWidth: 45,
        halign: "right",
      },

      2: {
        cellWidth: 45,
        halign: "right",
      },

      3: {
        cellWidth: 45,
        halign: "right",
      },

      4: {
        cellWidth: 45,
        halign: "right",
      },

      5: {
        cellWidth: 45,
        halign: "right",
      },
    },

    didParseCell(data) {
      if (data.section === "body") {
        data.cell.styles.fontStyle = "bold";

        data.cell.styles.fillColor =
          PDFCOLORSHEME.BACK_COLOR_GRAND_TOTAL;
      }
    },
  });
}